import React from 'react';

const NotFoundError = () => {
  return <h2 className="text-center pt-5">The requested page could not be found.</h2>;
};

export default NotFoundError;
